import React, { useState } from 'react';

function QuestionCard({ question, onVote, hasVoted }) {
  const [selectedChoice, setSelectedChoice] = useState(null);
  
  const totalVotes = (question.votesA || 0) + (question.votesB || 0);
const percentA = totalVotes > 0 ? Math.round(((question.votesA || 0) / totalVotes) * 100) : 0;
const percentB = totalVotes > 0 ? Math.round(((question.votesB || 0) / totalVotes) * 100) : 0;

  const handleVote = (choice) => {
    setSelectedChoice(choice);
    onVote(question.id, choice);
  };

  if (hasVoted) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 mb-4 border-4 border-atc-yellow">
        <h3 className="text-xl font-bold text-atc-purple mb-4">{question.text}</h3>
        
        <div className="space-y-3">
          <div className="bg-green-100 rounded-lg p-4">
            <div className="flex justify-between items-center">
              <span className="text-lg">👍 YES</span>
              <span className="text-2xl font-bold text-atc-purple">
                {question.votesA} ({percentA}%)
              </span>
            </div>
          </div>
          
          <div className="bg-red-100 rounded-lg p-4">
            <div className="flex justify-between items-center">
              <span className="text-lg">👎 NO</span>
              <span className="text-2xl font-bold text-atc-purple">
                {question.votesB} ({percentB}%)
              </span>
            </div>
          </div>
        </div>
        
        <p className="text-sm text-gray-500 mt-4 text-center">
          Total votes: {totalVotes}
        </p>
      </div>
    );
  }

  // Calculate time remaining
const getTimeRemaining = () => {
  if (!question.createdAt) return 'Expires in 24h';
  
  const createdDate = question.createdAt.toDate();
  const expiresAt = new Date(createdDate.getTime() + (24 * 60 * 60 * 1000));
  const now = new Date();
  const timeLeft = expiresAt - now;
  
  const hoursLeft = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  
  if (hoursLeft > 0) {
    return `Expires in ${hoursLeft}h ${minutesLeft}m`;
  } else if (minutesLeft > 0) {
    return `Expires in ${minutesLeft}m`;
  } else {
    return 'Expired';
  }
};

return (
  <div className="bg-white rounded-lg shadow-lg p-6 mb-4 border-4 border-atc-yellow">
    <div className="flex justify-between items-start mb-2">
      <h3 className="text-xl font-bold text-atc-purple flex-1">{question.text}</h3>
      <span className="text-xs font-semibold text-orange-600 bg-orange-100 px-3 py-1 rounded-full ml-2 whitespace-nowrap">
        ⏱️ {getTimeRemaining()}
      </span>
    </div>
    
    <div className="flex gap-4 mt-6">
      <button
        onClick={() => handleVote('A')}
        className="flex-1 bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-6 rounded-lg text-lg transition-colors"
      >
        👍 YES
      </button>
      
      <button
        onClick={() => handleVote('B')}
        className="flex-1 bg-red-500 hover:bg-red-600 text-white font-bold py-4 px-6 rounded-lg text-lg transition-colors"
      >
        👎 NO
      </button>
    </div>
    
    <p className="text-sm text-gray-500 mt-4 text-center">
      Vote to see what others chose
    </p>
  </div>
);
}

export default QuestionCard;